import { render, staticRenderFns } from "./MortgageListDisplay.vue?vue&type=template&id=bf17ff26"
import script from "./MortgageListDisplay.vue?vue&type=script&lang=js"
export * from "./MortgageListDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports